module.exports = __webpack_public_path__ + "img/123.a0e49ab.jpg";